export default {
	namespaced: true,

	state: {
		// (state) init -> app
		app: {
			default_: { 
				info: {},
				lang: {},
				link: {},
				style: {}
			},
			menuItems: {
				info: {},
				lang: {},
				link: {},
				style: {
					menuButton: {
						block: 'MenuButtonBlock',
						color: 'MenuButtonColor',
						dark: 'MenuButtonDark',
						depressed: 'MenuButtonDepressed',
						elevation: 'MenuButtonElevation',
						flat: 'MenuButtonFlat',
						large: 'MenuButtonLarge',
						light: 'MenuButtonLight',
						outlined: 'MenuButtonOutlined',
						rounded: 'MenuButtonRounded',
						small: 'MenuButtonSmall'
					}
				}
			}
		}, 
		// (state) init -> component
		component: {
			default_: { 
				info: {},
				lang: {},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					}
				}
			},
			// (state) chat list
			chatList: {
				info: {},
				lang: {
					title: 'Chat List'
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					list: {
						color: 'ListColor',
						dark: 'ListDark',
						dense: 'ListDense',
						elevation: 'ListElevation',
						flat: 'ListFlat',
						light: 'ListLight',
						nav: 'ListNav',
						rounded: 'ListRounded',
						shaped: 'ListShaped',
						threeLine: 'ListThreeLine',
						tile: 'ListTile',
						twoLine: 'ListTwoLine'
					}
				}
			},
			// (state) menu list
			menuList: {
				info: {},
				lang: {
					title: 'Menu List',
					loginButtonTitle: 'Login',
					logoutButtonTitle: 'Log Out'
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					list: {
						color: 'ListColor',
						dark: 'ListDark',
						dense: 'ListDense',
						elevation: 'ListElevation',
						flat: 'ListFlat',
						light: 'ListLight',
						nav: 'ListNav',
						rounded: 'ListRounded',
						shaped: 'ListShaped',
						threeLine: 'ListThreeLine',
						tile: 'ListTile',
						twoLine: 'ListTwoLine'
					}
				}
			},
			// (state) messagebar anonymous form
			messagebarAnonymousForm: {
				info: {},
				lang: {
					verifyButton: 'Verify',
					cancelButton: 'Cancel',

					// phone
					phone: 'Enter your phone number to chat as an anonymous user',
					phoneHint: null, // for temporary hint
					phoneMessage: null, // for persistent hint
							page: {
						animation: 'AnimatedFadeIn'
					},
					phonePlaceholder: null,
					phonePrefix: '08',
					phoneSuffix: null,

					phoneMask: '##-####-####', 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					phoneType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// otp
					otp: 'Input OTP',

					otpHint: null, // for temporary hint
					otpMessage: null, // for persistent hint
					otpPlaceholder: null,
					otpPrefix: null,
					otpSuffix: null,

					otpMask: null 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####
				},
				link: {},
				style: {
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					verifyButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					}
				}
			},
			// (state) messagebar footer
			messagebarFooter: {
				info: {},
				lang: {
					textMessage: 'Text message',

					verifyButton: 'Verify',

					// login by phone
					phone: 'Phone',
					phoneHint: null, // for temporary hint
					phoneMessage: null, // for persistent hint
					phonePlaceholder: null,
					phonePrefix: '08',
					phoneSuffix: null,

					phoneMask: '##-####-####', 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					phoneType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// otp
					otp: 'Input OTP',

					otpHint: null, // for temporary hint
					otpMessage: null, // for persistent hint
					otpPlaceholder: null,
					otpPrefix: null,
					otpSuffix: null,

					otpMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					footer: {
						color: null,
						dark: false,
						light: false
					},
					chip: {
						color: 'ChipColor',
						dark: 'ChipDark',
						label: 'ChipLabel',  // Removes circle edges
						light: 'ChipLight',
						outlined: 'ChipOutlined',
						small: 'ChipSmall',
						textColor: 'ChipTextColor'
					},
					textarea: {
						autoGrow: 'TextareaAutoGrow',
						backgroundColor: 'TextareaBackgroundColor',
						clearable: 'TextareaClearable',
						color: 'TextareaColor',
						counter: 'TextareaCounter', // boolean or number
						dark: 'TextareaDark',
						filled: 'TextareaFilled',
						flat: 'TextareaFlat',
						light: 'TextareaLight',
						outlined: 'TextareaOutlined',
						rows: 'TextareaRows', // default value = 3
						solo: 'TextareaSolo',
						soloInverted: 'TextareaSoloInverted' // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) progress circular
			progressCircular: {
				info: {},
				lang: {},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					progressCircular: {
						color: null,
						indeterminate: true,
						size: 24,
						value: 0,
						width: 3
					}
				}
			},
			// (state) progress linear
			progressLinear: {
				info: {},
				lang: {},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					progressLinear: {
						bufferValue: 100,
						color: 'primary',
						indeterminate: true,
						value: 0
					}
				}
			},
			// (state) searchbar list
			searchbarList: {
				info: {},
				lang: {
					title: 'Searchbar',

					startDate: 'Search Start Date',
					endDate: 'Search End Date',

					searchTag: 'Search Tag',
					searchWord: 'Search Word',

					searchButton: 'Search Button'
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					list: {
						color: 'ListColor',
						dark: 'ListDark',
						dense: 'ListDense',
						elevation: 'ListElevation',
						flat: 'ListFlat',
						light: 'ListLight',
						nav: 'ListNav',
						rounded: 'ListRounded',
						shaped: 'ListShaped',
						threeLine: 'ListThreeLine',
						tile: 'ListTile',
						twoLine: 'ListTwoLine'
					},
					searchButton: {
						block: 'BlockButtonBlock',
						color: 'BlockButtonColor',
						dark: 'BlockButtonDark',
						depressed: 'BlockButtonDepressed',
						elevation: 'BlockButtonElevation',
						flat: 'BlockButtonFlat',
						large: 'BlockButtonLarge',
						light: 'BlockButtonLight',
						outlined: 'BlockButtonOutlined',
						rounded: 'BlockButtonRounded',
						small: 'BlockButtonSmall'
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					}
				}
			},
			// (state) setting list
			settingList: {
				info: {},
				lang: {
					title: 'Setting'
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					list: {
						color: 'ListColor',
						dark: 'ListDark',
						dense: 'ListDense',
						elevation: 'ListElevation',
						flat: 'ListFlat',
						light: 'ListLight',
						nav: 'ListNav',
						rounded: 'ListRounded',
						shaped: 'ListShaped',
						threeLine: 'ListThreeLine',
						tile: 'ListTile',
						twoLine: 'ListTwoLine'
					}
				}
			},
			// (state) setting navigation drawer
			settingNavigationDrawer: {
				info: {},
				lang: {
					closeButton: 'Close'
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					closeButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					navigationDrawer: {
						color: null,
						dark: false,
						light: false,
						width: 280
					},
					list: {
						color: 'ListColor',
						dark: 'ListDark',
						dense: 'ListDense',
						elevation: 'ListElevation',
						flat: 'ListFlat',
						light: 'ListLight',
						nav: 'ListNav',
						rounded: 'ListRounded',
						shaped: 'ListShaped',
						threeLine: 'ListThreeLine',
						tile: 'ListTile',
						twoLine: 'ListTwoLine'
					}
				}
			},
			// (state) timeine message body card
			timelineMessageBodyCard: {
				info: {},
				lang: {
					openLinkButton: 'Open Link'
				},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					chip: {
						color: 'LabelChipColor',
						dark: 'LabelChipDark',
						label: 'LabelChipLabel',  // Removes circle edges
						light: 'LabelChipLight',
						outlined: 'LabelChipOutlined',
						small: 'LabelChipSmall',
						textColor: 'LabelChipTextColor'
					},
					messageCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					}
				}
			},
			// (state) timeline message header card
			timelineMessageHeaderCard: {
				info: {},
				lang: {},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					chip: {
						color: 'LabelChipColor',
						dark: 'LabelChipDark',
						label: 'LabelChipLabel',  // Removes circle edges
						light: 'LabelChipLight',
						outlined: 'LabelChipOutlined',
						small: 'LabelChipSmall',
						textColor: 'LabelChipTextColor'
					},
					messageCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					}
				}
			},
			// (state) toolbar
			toolbar: {
				info: {},
				lang: {
					title: null
				},
				link: {
					title: {
						to: {
							default: '/',
							admin: '/admin',
							point: '/point',
							recruit: '/recruit',
							sales: '/sales',
							training: '/training'
						}
					}
				},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					title: {
						style: 'ToolbarTitleStyle'
					},
					logoImage:{
						url: require('~/assets/logo.png')
					},
					menu: {
						dark: false,
						light: false
					},
					toolbar: {
						color: null,
						collapseOnScroll: false,
						dark: false,
						elevation: null,
						elevateOnScroll: false,
						flat: false,
						hideOnScroll: false,
						invertedScroll: false,
						light: false
					},
					menuButton: {
						block: 'MenuButtonBlock',
						color: 'MenuButtonColor',
						dark: 'MenuButtonDark',
						depressed: 'MenuButtonDepressed',
						elevation: 'MenuButtonElevation',
						flat: 'MenuButtonFlat',
						large: 'MenuButtonLarge',
						light: 'MenuButtonLight',
						outlined: 'MenuButtonOutlined',
						rounded: 'MenuButtonRounded',
						small: 'MenuButtonSmall',
						tile: 'MenuButtonTile'
					},
					collapsedMenuButton: {
						block: 'MenuButtonBlock',
						color: 'MenuButtonColor',
						dark: 'MenuButtonDark',
						depressed: 'MenuButtonDepressed',
						elevation: 'MenuButtonElevation',
						flat: 'MenuButtonFlat',
						large: 'MenuButtonLarge',
						light: 'MenuButtonLight',
						outlined: 'MenuButtonOutlined',
						rounded: 'MenuButtonRounded',
						small: 'MenuButtonSmall',
						tile: 'MenuButtonTile'
					}
				}
			},
			// (state) toolbar tabs
			toolbarTabs: {
				info: {},
				lang: {},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					tabs: { // tab bar
						backgroundColor: null,
						centered: false,
						color: null,
						dark: false,
						grow: false,
						hideSlider: false,
						light: false,
						nextIcon: 'navigate_next',
						prevIcon: 'navigate_before',
						sliderColor: null
					},
					tabsItems: { // content under tab bar
						continuous: false,
						dark: false,
						light: false,
						nextIcon: 'navigate_next',
						prevIcon: 'navigate_before',
						showArrows: false
					},
					menuButton: {
						block: 'MenuButtonBlock',
						color: 'MenuButtonColor',
						dark: 'MenuButtonDark',
						depressed: 'MenuButtonDepressed',
						elevation: 'MenuButtonElevation',
						flat: 'MenuButtonFlat',
						large: 'MenuButtonLarge',
						light: 'MenuButtonLight',
						outlined: 'MenuButtonOutlined',
						rounded: 'MenuButtonRounded',
						small: 'MenuButtonSmall',
						tile: 'MenuButtonTile'
					}
				}
			},
			// (state) version info footer
			versionInfoFooter: {
				info: {},
				lang: {},
				link: {},
				style: {
					component: {
						animation: 'AnimatedFadeIn'
					},
					footer: {
						color: null,
						dark: false,
						light: false
					},
					versionButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					}
				}
			}
		},
		// (state) init -> page
		page: {
			// (state) default page
			default_: {
				info: {
					isFluidPage: false,

					hideToolbarMenu: true,
					hidePageContents: true,
					showPageTitle: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: 'Oops',
					pageSubTitle: 'Something is wrong, please reload.',
					pageTitleButton: 'Reload'
				},
				link: {
					pageTitleButton: {
						to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) alert page
			alert_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					alert: {
						border: 'AlertBorder',
						color: 'AlertColor',
						coloredBorder: 'AlertColoredBorder',
						dark: 'AlertDark',
						dense: 'AlertDense',
						elevation: 'AlertElevation',
						icon: 'AlertIcon',
						light: 'AlertLight',
						outlined: 'AlertOutlined',
						prominent: 'AlertProminent',
						text: 'AlertText',
						tile: 'AlertTile'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) banner page
			banner_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					banner: {
						color: 'BannerColor',
						dark: 'BannerDark',
						elevation: 'BannerElevation',
						iconColor: 'BannerIconColor',
						light: 'BannerLight',
						outlined: 'BannerOutlined',
						rounded: 'BannerRounded',
						shaped: 'BannerShaped',
						singleLine: 'BannerSingleLine',
						tile: 'BannerTile'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) calendar page
			calendar_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					calendarSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					calendar: {
						color: 'primary',
						dark: false,
						light: false
					},
					navigationButton: {
						block: 'SmallButtonBlock',
						color: 'SmallButtonColor',
						dark: 'SmallButtonDark',
						depressed: 'SmallButtonDepressed',
						elevation: 'SmallButtonElevation',
						flat: 'SmallButtonFlat',
						large: 'SmallButtonLarge',
						light: 'SmallButtonLight',
						outlined: 'SmallButtonOutlined',
						rounded: 'SmallButtonRounded',
						small: 'SmallButtonSmall'
					},
					eventButton: {
						block: 'BlockButtonBlock',
						color: 'BlockButtonColor',
						dark: 'BlockButtonDark',
						depressed: 'BlockButtonDepressed',
						elevation: 'BlockButtonElevation',
						flat: 'BlockButtonFlat',
						large: 'BlockButtonLarge',
						light: 'BlockButtonLight',
						outlined: 'BlockButtonOutlined',
						rounded: 'BlockButtonRounded',
						small: 'BlockButtonSmall'
					},
					actionButton: {
						block: 'SmallButtonBlock',
						color: 'SmallButtonColor',
						dark: 'SmallButtonDark',
						depressed: 'SmallButtonDepressed',
						elevation: 'SmallButtonElevation',
						flat: 'SmallButtonFlat',
						large: 'SmallButtonLarge',
						light: 'SmallButtonLight',
						outlined: 'SmallButtonOutlined',
						rounded: 'SmallButtonRounded',
						small: 'SmallButtonSmall'
					}
				}
			},
			// (state) card page
			card_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					card: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					chip: {
						color: 'ChipColor',
						dark: 'ChipDark',
						label: 'ChipLabel',  // Removes circle edges
						light: 'ChipLight',
						outlined: 'ChipOutlined',
						small: 'ChipSmall',
						textColor: 'ChipTextColor'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) carousel page
			carousel_: {
				info: {
					isFluidPage: true,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					videoOpenLinkButton: 'Open Page',
					videoResumeButton: 'Resume',
					videoReplayButton: 'Replay'
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					carousel: {
						continuous: 'CarouselContinuous',
						cycle: 'CarouselCycle',
						dark: 'CarouselDark',
						delimiterIcon: 'CarouselDelimiterIcon',
						flat: 'CarouselFlat',
						hideDelimiters: 'CarouselHideDelimiters',
						hideDelimiterBackground: 'CarouselHideDelimiterBackground',
						interval: 'CarouselInterval',
						light: 'CarouselLight',
						nextIcon: 'CarouselNextIcon',
						prevIcon: 'CarouselPrevIcon',
						progress: 'CarouselProgress',
						progressColor: 'CarouselProgressColor',
						showArrows: 'CarouselShowArrows',
						showArrowsOnHover: 'CarouselShowArrowsOnHover'
					},
					videoResumeButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					},
					videoReplayButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					},
					videoOpenLinkButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					}
				}
			},
			// (state) csv stepper
			csvStepper_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
					//	to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) data table page
			dataTable_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					},

					headers: [
						{
							text: 'Title',
							value: 'title',
						},
						{	
							text: 'Column 1', 
							value: 'col1' 
						},
						{
							text: 'Column 2',
							value: 'col2'
						},
						{
							text: 'Column 3',
							value: 'col3'
						},
						{
							text: 'Column 4',
							value: 'col4'
						},
						{	
							text: 'Actions',
							value: 'action',
						},
					]
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					videoOpenLinkButton: 'Open Page',
					videoResumeButton: 'Resume',
					videoReplayButton: 'Replay'
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					dataTable: {
						dark: false,
						dense: false,
						light: false
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) expansion panel page
			expansionPanel_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					card: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					chip: {
						color: 'ChipColor',
						dark: 'ChipDark',
						label: 'ChipLabel',  // Removes circle edges
						light: 'ChipLight',
						outlined: 'ChipOutlined',
						small: 'ChipSmall',
						textColor: 'ChipTextColor'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) ifram page
			iframe_: {
				info: {
					isFluidPage: true,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) input page
			input_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					message: { 
						title: null,
						text: 'Message Text'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					// input mode
					submitButton: 'Submit',

					// submit mode
					backButton: 'Back',
					confirmButton: 'Confirm',

					// finsih mode
					finishText: 'Finish',
					okButton: 'OK',
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					},

					okButton: {
						to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					inputCheckbox: {
						animation: 'AnimatedFadeIn'
					},
					inputCombobox: {
						animation: 'AnimatedFadeIn'
					},
					inputComboboxMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputRadioButton: {
						animation: 'AnimatedFadeIn'
					},
					inputSelect: {
						animation: 'AnimatedFadeIn'
					},
					inputSelectMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputSlider: {
						animation: 'AnimatedFadeIn'
					},
					inputSwitch: {
						animation: 'AnimatedFadeIn'
					},
					inputTextarea: {
						animation: 'AnimatedFadeIn'
					},
					inputTextField: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					errorMessage: {
						style: {
							color: 'red'
						}
					},
					stepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					stepperSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					stepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					stepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					stepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					questionActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},

					// questions
					checkbox: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					combobox: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					comboboxMultiple: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					radioButton: { 
						backgroundColor: null,
						color: null,
						column: true,
						dark: false,
						light: false,
						row: false
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					selectMultiple: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					slider: {
						alwaysDirty: false, // always show the thumb label
						backgroundColor: null,
						color: null,
						dark: false,
						inverseLabel: false, // Reverse the label position
						light: false,
						thumbColor: null,
						thumbLabel: true,
						thumbSize: null, // default value = 32
						ticks: false,
						tickSize: null, // default value = 1
						trackColor: null
					},
					switch: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					textarea: {
						autoGrow: 'TextareaAutoGrow',
						backgroundColor: 'TextareaBackgroundColor',
						clearable: 'TextareaClearable',
						color: 'TextareaColor',
						counter: 'TextareaCounter', // boolean or number
						dark: 'TextareaDark',
						filled: 'TextareaFilled',
						flat: 'TextareaFlat',
						light: 'TextareaLight',
						outlined: 'TextareaOutlined',
						rows: 'TextareaRows', // default value = 3
						solo: 'TextareaSolo',
						soloInverted: 'TextareaSoloInverted' // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					}
				}
			},
			// (state) input with stepper page
			inputWithStepper_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					},

					input: {},

					maxScore: 100,
					minScore: 0,
					timeLimit: 600
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					// outer stepper
					// (input mode)
					inputTitle: 'Input',
					submitButton: 'Submit',

					// (submit mode)
					submitTitle: 'Submit',
					backButton: 'Back',
					confirmButton: 'Confirm',

					// (finsih mode)
					finishTitle: 'Finish',
					finishText: 'Finish',
					okButton: 'OK',

					// inner step
					backStepButton: 'Back Step',
					nextStepButton: 'Next Step'
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					},

					okButton: {
						to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					inputCheckbox: {
						animation: 'AnimatedFadeIn'
					},
					inputCombobox: {
						animation: 'AnimatedFadeIn'
					},
					inputComboboxMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputRadioButton: {
						animation: 'AnimatedFadeIn'
					},
					inputSelect: {
						animation: 'AnimatedFadeIn'
					},
					inputSelectMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputSlider: {
						animation: 'AnimatedFadeIn'
					},
					inputSwitch: {
						animation: 'AnimatedFadeIn'
					},
					inputTextarea: {
						animation: 'AnimatedFadeIn'
					},
					inputTextField: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					errorMessage: {
						style: {
							color: 'red'
						}
					},
					outerStepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					outerStepperSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					outerStepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					outerStepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					outerStepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					innerStepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					innerStepperSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					innerStepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					innerStepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					innerStepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					questionActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},

					// questions
					checkbox: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					combobox: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					comboboxMultiple: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					radioButton: { 
						backgroundColor: null,
						color: null,
						column: true,
						dark: false,
						light: false,
						row: false
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					selectMultiple: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					slider: {
						alwaysDirty: false, // always show the thumb label
						backgroundColor: null,
						color: null,
						dark: false,
						inverseLabel: false, // Reverse the label position
						light: false,
						thumbColor: null,
						thumbLabel: true,
						thumbSize: null, // default value = 32
						ticks: false,
						tickSize: null, // default value = 1
						trackColor: null
					},
					switch: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					textarea: {
						autoGrow: 'TextareaAutoGrow',
						backgroundColor: 'TextareaBackgroundColor',
						clearable: 'TextareaClearable',
						color: 'TextareaColor',
						counter: 'TextareaCounter', // boolean or number
						dark: 'TextareaDark',
						filled: 'TextareaFilled',
						flat: 'TextareaFlat',
						light: 'TextareaLight',
						outlined: 'TextareaOutlined',
						rows: 'TextareaRows', // default value = 3
						solo: 'TextareaSolo',
						soloInverted: 'TextareaSoloInverted' // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					}
				}
			},
			// (state) sheet page
			sheet_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					headerSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					bodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					videoButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) slide group page
			slideGroup_: {
				info: {
					isFluidPage: true,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					slideGroup: {
						dark: false,
						light: false,
						nextIcon: 'keyboard_arrow_right',
						prevIcon: 'keyboard_arrow_left'
					},
					card: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					chip: {
						color: 'ChipColor',
						dark: 'ChipDark',
						label: 'ChipLabel',  // Removes circle edges
						light: 'ChipLight',
						outlined: 'ChipOutlined',
						small: 'ChipSmall',
						textColor: 'ChipTextColor'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) stepper page
			stepper_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					// stepper
					backButton: 'Back',
					nextButton: 'Next',
					finishButton: 'Finish',
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					},

					finishButton: {
						to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					stepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					stepperCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					stepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					stepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					stepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) tab page
			tab_: {
				info: {
					isFluidPage: true,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					tabs: {
						backgroundColor: null,
						color: null,
						dark: false,
						hideSlider: false,
						light: false,
						sliderColor: null
					},
					tab: {
						dark: false,
						light: false
					},
					headerSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					bodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					videoButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) treeview page
			treeview_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					headerSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					bodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					treeviewSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					actionButton: {
						block: 'BlockButtonBlock',
						color: 'BlockButtonColor',
						dark: 'BlockButtonDark',
						depressed: 'BlockButtonDepressed',
						elevation: 'BlockButtonElevation',
						flat: 'BlockButtonFlat',
						large: 'BlockButtonLarge',
						light: 'BlockButtonLight',
						outlined: 'BlockButtonOutlined',
						rounded: 'BlockButtonRounded',
						small: 'BlockButtonSmall'
					},
					treeview: {
						activatable: true,
						color: null,
						dark: false,
						dense: false,
						expandIcon: 'arrow_drop_down',
						hoverable: false,
						light: false,
						multipleActive: false,
						offIcon: 'check_box_outline_blank',
						onIcon: 'check_box',
						openAll: false,
						openOnClick: false,
						rounded: false,
						selectable: false,
						selectedColor: null,
						selectionType: 'leaf',
						shaped: false,
						transition: false
					}
				}
			},
			// (state) window page
			window_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					banner: {
						color: 'BannerColor',
						dark: 'BannerDark',
						elevation: 'BannerElevation',
						iconColor: 'BannerIconColor',
						light: 'BannerLight',
						outlined: 'BannerOutlined',
						rounded: 'BannerRounded',
						shaped: 'BannerShaped',
						singleLine: 'BannerSingleLine',
						tile: 'BannerTile'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) recruit page
			recruit: {
				info: {
					hidePageContents: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						recruit: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					pageTitle: 'Your session is expired',
					pageSubTitle: 'Please reload the page.',
					pageTitleButton: 'Reload',

					scheduleSheetOpenSchedule: 'Open Schedule',
					scheduleSheetInputDate: 'Input Date',

					stepTabCompletedStep: 'Completed',
					stepTabPreviousStep: 'Previous Step',
					stepTabNextStep: 'Next Step',
					stepTabBackToSchedule: 'Back To Recruitment'
				},
				link: {
					pageTitleButton: {
						to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					navigationDrawer: {
						dark: false,
						light: false,
						right: false
					},
					scheduleSheetHeaderSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					scheduleSheetBodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					scheduleSheetTextField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					scheduleSheetActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					scheduleSheetOpenModuleButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					stepTabTabs: {
						backgroundColor: null,
						color: null,
						dark: false,
						hideSlider: false,
						light: false,
						sliderColor: null
					},
					stepTabHeaderSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					stepTabBodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					stepTabActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					stepTabOpenStepButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					stepTabNavigationButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			recruitInput_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					message: { 
						title: null,
						text: 'Message Text'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					// input mode
					inputTitle: 'Input',
					submitButton: 'Submit',

					// submit mode
					submitTitle: 'Submit',
					backButton: 'Back',
					confirmButton: 'Confirm',

					// finsih mode
					finishTitle: 'Finish',
					finishText: 'Finish',
					okButton: 'OK',
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					},

					okButton: {
						to: '/'
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					inputCheckbox: {
						animation: 'AnimatedFadeIn'
					},
					inputCombobox: {
						animation: 'AnimatedFadeIn'
					},
					inputComboboxMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputRadioButton: {
						animation: 'AnimatedFadeIn'
					},
					inputSelect: {
						animation: 'AnimatedFadeIn'
					},
					inputSelectMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputSlider: {
						animation: 'AnimatedFadeIn'
					},
					inputSwitch: {
						animation: 'AnimatedFadeIn'
					},
					inputTextarea: {
						animation: 'AnimatedFadeIn'
					},
					inputTextField: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					errorMessage: {
						style: {
							color: 'red'
						}
					},
					stepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					stepperSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					stepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					stepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					stepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					questionActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},

					// questions
					checkbox: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					combobox: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					comboboxMultiple: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					radioButton: { 
						backgroundColor: null,
						color: null,
						column: true,
						dark: false,
						light: false,
						row: false
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					selectMultiple: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					slider: {
						alwaysDirty: false, // always show the thumb label
						backgroundColor: null,
						color: null,
						dark: false,
						inverseLabel: false, // Reverse the label position
						light: false,
						thumbColor: null,
						thumbLabel: true,
						thumbSize: null, // default value = 32
						ticks: false,
						tickSize: null, // default value = 1
						trackColor: null
					},
					switch: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					textarea: {
						autoGrow: 'TextareaAutoGrow',
						backgroundColor: 'TextareaBackgroundColor',
						clearable: 'TextareaClearable',
						color: 'TextareaColor',
						counter: 'TextareaCounter', // boolean or number
						dark: 'TextareaDark',
						filled: 'TextareaFilled',
						flat: 'TextareaFlat',
						light: 'TextareaLight',
						outlined: 'TextareaOutlined',
						rows: 'TextareaRows', // default value = 3
						solo: 'TextareaSolo',
						soloInverted: 'TextareaSoloInverted' // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					}
				}
			},
			// (state) sales page
			sales: {
				info: {
					hidePageContents: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						sales: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					pageTitle: 'Your session is expired',
					pageSubTitle: 'Please reload the page.',
					pageTitleButton: 'Reload',

					productCardProductCodeTitle: null,
					productCardProductCodeSubTitle: 'Product Code',
					productCardProductCodeText: 'Tap to enter product code',
					productCardEnterProductCode: 'Enter product code',
					productCardEnterSerialNumber: 'Enter Serial Number',

					serialNumberInputInputTitle: 'Input',
					serialNumberInputNextButton: 'Next',
					serialNumberInputBackButton: 'Back',
					serialNumberInputSubmitTitle: 'Submit',
					serialNumberInputSubmitButton: 'Submit',
					serialNumberInputConfirmButton: 'Confirm',
					serialNumberInputFinishTitle: 'Finish',
					serialNumberInputFinishText: 'Finished',
					serialNumberInputOkButton: 'OK',
					serialNumberSubTotal: 'Sub Total',
					serialNumberTax: 'Tax',
					serialNumberTotal: 'Total',
				},
				link: {
					pageTitleButton: {
						to: '/'
					},

					serialNumberInputOkButton: {
						to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					// product card
					productCardProductCodeImage: {
						url: 'DummyImageProductCode'
					},
					productCardCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					productCardChip: {
						color: 'ChipColor',
						dark: 'ChipDark',
						label: 'ChipLabel',  // Removes circle edges
						light: 'ChipLight',
						outlined: 'ChipOutlined',
						small: 'ChipSmall',
						textColor: 'ChipTextColor'
					},
					productCardActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					productCardEnterProductCodeButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					productCardEnterSerialNumberButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					productCardInputButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},

					// serial number input
					serialNumberInputInputCheckbox: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputCombobox: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputComboboxMultiple: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputRadioButton: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputSelect: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputSelectMultiple: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputSlider: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputSwitch: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputTextarea: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputInputTextField: {
						animation: 'AnimatedFadeIn'
					},
					serialNumberInputErrorMessage: {
						style: {
							color: 'red'
						}
					},
					serialNumberInputStepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					serialNumberInputStepperSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					serialNumberInputStepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					serialNumberInputStepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					serialNumberInputStepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					serialNumberInputQuestionActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},

					// questions
					checkbox: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					combobox: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					comboboxMultiple: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					radioButton: { 
						backgroundColor: null,
						color: null,
						column: true,
						dark: false,
						light: false,
						row: false
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					selectMultiple: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					slider: {
						alwaysDirty: false, // always show the thumb label
						backgroundColor: null,
						color: null,
						dark: false,
						inverseLabel: false, // Reverse the label position
						light: false,
						thumbColor: null,
						thumbLabel: true,
						thumbSize: null, // default value = 32
						ticks: false,
						tickSize: null, // default value = 1
						trackColor: null
					},
					switch: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					textarea: {
						autoGrow: 'TextareaAutoGrow',
						backgroundColor: 'TextareaBackgroundColor',
						clearable: 'TextareaClearable',
						color: 'TextareaColor',
						counter: 'TextareaCounter', // boolean or number
						dark: 'TextareaDark',
						filled: 'TextareaFilled',
						flat: 'TextareaFlat',
						light: 'TextareaLight',
						outlined: 'TextareaOutlined',
						rows: 'TextareaRows', // default value = 3
						solo: 'TextareaSolo',
						soloInverted: 'TextareaSoloInverted' // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					}
				}
			},
			// (state) training page
			training: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					showPageTitle: true,
					hidePageContents: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						training: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					pageTitle: 'Let\'s start training',
					pageSubTitle: 'Click START button.',
					pageTitleButton: 'Start',

					openCourse: 'Open Course',

					moduleSheetOpenModule: 'Open Module',

					sectionTabCompletedSection: 'Completed',
					sectionTabPreviousSection: 'Previous Section',
					sectionTabNextSection: 'Next Section',
					sectionTabBackToCourse: 'Back To Course'
				},
				link: {
					pageTitleButton: {
						to: {
							name: 'trainingCourse',
							params: {
								courseCode: 'new'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					// (card video)
					videoButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					// (card carousel)
					carousel: {
						continuous: 'TrainingCarouselContinuous',
						cycle: 'TrainingCarouselCycle',
						dark: 'TrainingCarouselDark',
						delimiterIcon: 'TrainingCarouselDelimiterIcon',
						flat: 'TrainingCarouselFlat',
						hideDelimiters: 'TrainingCarouselHideDelimiters',
						hideDelimiterBackground: 'TrainingCarouselHideDelimiterBackground',
						interval: 'TrainingCarouselInterval',
						light: 'TrainingCarouselLight',
						nextIcon: 'TrainingCarouselNextIcon',
						prevIcon: 'TrainingCarouselPrevIcon',
						progress: 'TrainingCarouselProgress',
						progressColor: 'TrainingCarouselProgressColor',
						showArrows: 'TrainingCarouselShowArrows',
						showArrowsOnHover: 'TrainingCarouselShowArrowsOnHover'
					},
					// course
					courseSheetOpenCourseButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					// section
					navigationDrawer: {
						dark: false,
						light: false,
						right: false
					},
					moduleSheetHeaderSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					moduleSheetBodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					moduleSheetActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					moduleSheetOpenModuleButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					sectionTabTabs: {
						backgroundColor: null,
						color: null,
						dark: false,
						hideSlider: false,
						light: false,
						sliderColor: null
					},
					sectionTabHeaderSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					sectionTabBodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					sectionTabActionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					sectionTabOpenTestButton: {
						block: 'BlockButtonBlock',
						color: 'BlockButtonColor',
						dark: 'BlockButtonDark',
						depressed: 'BlockButtonDepressed',
						elevation: 'BlockButtonElevation',
						flat: 'BlockButtonFlat',
						large: 'BlockButtonLarge',
						light: 'BlockButtonLight',
						outlined: 'BlockButtonOutlined',
						rounded: 'BlockButtonRounded',
						small: 'BlockButtonSmall'
					},
					sectionTabNavigationButton: {
						block: 'BlockButtonBlock',
						color: 'BlockButtonColor',
						dark: 'BlockButtonDark',
						depressed: 'BlockButtonDepressed',
						elevation: 'BlockButtonElevation',
						flat: 'BlockButtonFlat',
						large: 'BlockButtonLarge',
						light: 'BlockButtonLight',
						outlined: 'BlockButtonOutlined',
						rounded: 'BlockButtonRounded',
						small: 'BlockButtonSmall'
					}
				}
			},
			trainingInput_: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					},

					message: { 
						title: null,
						text: 'Message Text'
					},

					maxScore: 100,
					minScore: 0,
					timeLimit: 600
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					// start mode
					startText: 'Start',
					startButton: 'Start',

					// input mode
					inputTitle: 'Input',
					submitButton: 'Submit',

					// submit mode
					submitTitle: 'Submit',
					backButton: 'Back',
					confirmButton: 'Confirm',

					// finsih mode
					finishTitle: 'Finish',
					finishText: 'Finish',
					okButton: 'OK',
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					},

					okButton: {
						to: {
							name: 'training',
							params: {
								courseCode: 'new',
								moduleCode: 'new'
							}
						}
					}
				},
				style: {
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					inputCheckbox: {
						animation: 'AnimatedFadeIn'
					},
					inputCombobox: {
						animation: 'AnimatedFadeIn'
					},
					inputComboboxMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputRadioButton: {
						animation: 'AnimatedFadeIn'
					},
					inputSelect: {
						animation: 'AnimatedFadeIn'
					},
					inputSelectMultiple: {
						animation: 'AnimatedFadeIn'
					},
					inputSlider: {
						animation: 'AnimatedFadeIn'
					},
					inputSwitch: {
						animation: 'AnimatedFadeIn'
					},
					inputTextarea: {
						animation: 'AnimatedFadeIn'
					},
					inputTextField: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					errorMessage: {
						style: {
							color: 'red'
						}
					},
					stepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					stepperSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					stepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					stepperBodyCard: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					stepperActionButton: {
						block: 'StepperActionButtonBlock',
						color: 'StepperActionButtonColor',
						dark: 'StepperActionButtonDark',
						depressed: 'StepperActionButtonDepressed',
						elevation: 'StepperActionButtonElevation',
						flat: 'StepperActionButtonFlat',
						large: 'StepperActionButtonLarge',
						light: 'StepperActionButtonLight',
						outlined: 'StepperActionButtonOutlined',
						rounded: 'StepperActionButtonRounded',
						small: 'StepperActionButtonSmall'
					},
					questionActionButton: {
						block: 'BlockButtonBlock',
						color: 'BlockButtonColor',
						dark: 'BlockButtonDark',
						depressed: 'BlockButtonDepressed',
						elevation: 'BlockButtonElevation',
						flat: 'BlockButtonFlat',
						large: 'BlockButtonLarge',
						light: 'BlockButtonLight',
						outlined: 'BlockButtonOutlined',
						rounded: 'BlockButtonRounded',
						small: 'BlockButtonSmall'
					},

					// questions
					checkbox: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					combobox: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					comboboxMultiple: {
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					radioButton: { 
						backgroundColor: null,
						color: null,
						column: true,
						dark: false,
						light: false,
						row: false
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					selectMultiple: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					slider: {
						alwaysDirty: false, // always show the thumb label
						backgroundColor: null,
						color: null,
						dark: false,
						inverseLabel: false, // Reverse the label position
						light: false,
						thumbColor: null,
						thumbLabel: true,
						thumbSize: null, // default value = 32
						ticks: false,
						tickSize: null, // default value = 1
						trackColor: null
					},
					switch: { 
						backgroundColor: null,
						color: null,
						dark: false,
						light: false
					},
					textarea: {
						autoGrow: 'TextareaAutoGrow',
						backgroundColor: 'TextareaBackgroundColor',
						clearable: 'TextareaClearable',
						color: 'TextareaColor',
						counter: 'TextareaCounter', // boolean or number
						dark: 'TextareaDark',
						filled: 'TextareaFilled',
						flat: 'TextareaFlat',
						light: 'TextareaLight',
						outlined: 'TextareaOutlined',
						rows: 'TextareaRows', // default value = 3
						solo: 'TextareaSolo',
						soloInverted: 'TextareaSoloInverted' // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					}
				}
			},
			// (state) admin page
			admin: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,
					
					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
					// stepper
					submitButton: 'Submit',
					nextButton: 'Next',
					backButton: 'Back',
					confirmButton: 'Confirm',
					okButton: 'OK',
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					// banner
					banner: {
						color: 'BannerColor',
						dark: 'BannerDark',
						elevation: 'BannerElevation',
						iconColor: 'BannerIconColor',
						light: 'BannerLight',
						outlined: 'BannerOutlined',
						rounded: 'BannerRounded',
						shaped: 'BannerShaped',
						singleLine: 'BannerSingleLine',
						tile: 'BannerTile'
					},
					// tabs
					tabs: {
						backgroundColor: 'transparent',
						color: 'primary',
						dark: false,
						hideSlider: true,
						light: false,
						sliderColor: null
					},
					tab: {
						dark: false,
						light: false
					},
					headerSheet: {
						color: 'FlatSheetColor',
						dark: 'FlatSheetDark',
						elevation: 'FlatSheetElevation',
						light: 'FlatSheetLight'
					},
					bodySheet: {
						color: 'FlatSheetColor',
						dark: 'FlatSheetDark',
						elevation: 'FlatSheetElevation',
						light: 'FlatSheetLight'
					},
					// stepper
					stepper: {
						dark: 'StepperDark',
						light: 'StepperLight',
						stepColor: 'StepperStepColor'
					},
					stepperCard: {
						color: 'FlatCardColor',
						dark: 'FlatCardDark',
						elevation: 'FlatCardElevation',
						flat: 'FlatCardFlat',
						hover: 'FlatCardHover',
						light: 'FlatCardLight',
						outlined: 'FlatCardOutlined',
						raised: 'FlatCardRaised',
						tile: 'FlatCardTile'
					},
					stepperHeaderCard: {
						color: 'OutlinedCardColor',
						dark: 'OutlinedCardDark',
						elevation: 'OutlinedCardElevation',
						flat: 'OutlinedCardFlat',
						hover: 'OutlinedCardHover',
						light: 'OutlinedCardLight',
						outlined: 'OutlinedCardOutlined',
						raised: 'OutlinedCardRaised',
						tile: 'OutlinedCardTile'
					},
					stepperBodyCard: {
						color: 'FlatCardColor',
						dark: 'FlatCardDark',
						elevation: 'FlatCardElevation',
						flat: 'FlatCardFlat',
						hover: 'FlatCardHover',
						light: 'FlatCardLight',
						outlined: 'FlatCardOutlined',
						raised: 'FlatCardRaised',
						tile: 'FlatCardTile'
					},
					stepperActionButton: {
						block: 'LargeButtonBlock',
						color: 'LargeButtonColor',
						dark: 'LargeButtonDark',
						depressed: 'LargeButtonDepressed',
						elevation: 'LargeButtonElevation',
						flat: 'LargeButtonFlat',
						large: 'LargeButtonLarge',
						light: 'LargeButtonLight',
						outlined: 'LargeButtonOutlined',
						rounded: 'LargeButtonRounded',
						small: 'LargeButtonSmall'
					}
				}
			},
			adminRegisterUserUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'registerUser'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminResetPasswordUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'resetPassword'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminUpdateUserUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'updateUser'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminChangeUserGroupUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'changeUserGroup'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminChangeUserOptionUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'changeUserOption'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminChangeSecurityGroupUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'changeSecurityGroup'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminChangeUserStatusUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'user',
								operationName: 'changeUserStatus'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminDeleteUserUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
					//	to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminCreateGroupUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'group',
								operationName: 'createGroup'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminUpdateGroupUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'group',
								operationName: 'updateGroup'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminDeleteGroupUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'group',
								operationName: 'deleteGroup'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			adminCreateVoucherUploadCsv: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						//
					},

					menuGroup: {
						admin: true
					},

					securityGroup: {
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,

					finishedText: 'CSV is submitted.'
				},
				link: {
					okButton: {
						to: {
							name: 'admin',
							params: {
								operationType: 'point',
								operationName: 'createVoucher'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) dashboard page
			dashboard: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						point: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) forget password page
			forgetPassword: {
				info: {
					hideToolbarMenu: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: true
					}
				},
				lang: {
					backButton: 'Back',
					resetButton: 'Reset',
					cancelButton: 'Cancel',
					requestReset: 'Request Reset',
					sendEmailLink: 'Send Email Link',
					sendOtp: 'Send OTP',
					challengeSecurityQuestion: 'Challenge Security Question',
					answerQuestion: 'Answer Question',
					submitChallengeButton: 'Submit',
					cancelChallengeButton: 'Cancel',
					resetPasswordButton: 'Reset',
					cancelResetPasswordButton: 'Cancel',
					okButton: 'OK',
					verifyButton: 'Verify',

					emailLinkText: 'Email link to login is sent to your email address.',
					requestedText: 'Request for resetting password is sent.<br>New password will be sent to the email address related to your username in 24 hours.',

					// select sign up options
					selectLoginOption: 'Select Login Option',
					selectLoginOptionPlaceholder: null,

					// sign up by username
					username: 'Username',
					usernameHint: null, // for temporary hint
					usernameMessage: null, // for persistent hint
					usernamePlaceholder: null,
					usernamePrefix: null,
					usernameSuffix: null,

					usernameMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					usernameType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// sign up by email
					email: 'Email',
					emailHint: null, // for temporary hint
					emailMessage: null, // for persistent hint
					emailPlaceholder: null,
					emailPrefix: null,
					emailSuffix: null,

					emailMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					emailType: 'email',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown
					
					// sign up by phone
					phone: 'Phone',
					phoneHint: null, // for temporary hint
					phoneMessage: null, // for persistent hint
					phonePlaceholder: null,
					phonePrefix: '08',
					phoneSuffix: null,

					phoneMask: '##-####-####', 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					phoneType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// otp
					otp: 'Input OTP',

					otpHint: null, // for temporary hint
					otpMessage: null, // for persistent hint
					otpPlaceholder: null,
					otpPrefix: null,
					otpSuffix: null,

					otpMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					// new password
					newPassword: 'New Password',

					newPasswordHint: null, // for temporary hint
					newPasswordMessage: null, // for persistent hint
					newPasswordPlaceholder: null,
					newPasswordPrefix: null,
					newPasswordSuffix: null,

					newPasswordMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					// sign up cofirm password
					confirmPassword: 'Confirm Password',

					confirmPasswordHint: null, // for temporary hint
					confirmPasswordMessage: null, // for persistent hint
					confirmPasswordPlaceholder: null,
					confirmPasswordPrefix: null,
					confirmPasswordSuffix: null,

					confirmPasswordMask: null
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####
				},
				link: {
					okButton: {
						replace: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: true,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					textFieldResetPassword: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					alert: {
						border: 'AlertBorder',
						color: 'AlertColor',
						coloredBorder: 'AlertColoredBorder',
						dark: 'AlertDark',
						dense: 'AlertDense',
						elevation: 'AlertElevation',
						icon: 'AlertIcon',
						light: 'AlertLight',
						outlined: 'AlertOutlined',
						prominent: 'AlertProminent',
						text: 'AlertText',
						tile: 'AlertTile'
					},
					backButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					},
					resetButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					},
					requestButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					challengeButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					submitChallengeButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelChallengeButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					resetPasswordButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelResetPasswordButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					},
					okButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					verifyButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) index page
			index: {
				info: {
					isFluidPage: false,

					hideToolbarMenu: true,
					hidePageContents: true,
					showPageTitle: true,

					contact: {
						//
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: 'Welcome',
					pageSubTitle: 'IncentivePointProgram',
					pageTitleButton: {
						nonUser: 'Login',
						user: 'Start'
					}
				},
				link: {
					pageTitleButton: {
						nonUser: {
							to: '/login'
						},
						user: {
							to: '/point'
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: 'IndexPageContainerStyle'
					},
					pageTitleSheet: {
						style: 'IndexPageTitleSheetStyle'
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) login page
			login: {
				info: {
					hideToolbarMenu: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: true
					}
				},
				lang: {
					cancelButton: 'Cancel',
					loginButton: 'Login',
					forgetPassword: 'Forget Password',
					signUp: 'Sign Up',

					// select login options
					selectLoginOption: 'Select Login Option',
					selectLoginOptionPlaceholder: null,

					// login by username
					username: 'Username',
					usernameHint: null, // for temporary hint
					usernameMessage: null, // for persistent hint
					usernamePlaceholder: null,
					usernamePrefix: null,
					usernameSuffix: null,

					usernameMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					usernameType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// login by email
					email: 'Email',
					emailHint: null, // for temporary hint
					emailMessage: null, // for persistent hint
					emailPlaceholder: null,
					emailPrefix: null,
					emailSuffix: null,

					emailMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					emailType: 'email',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown
					
					// login by phone
					phone: 'Phone',
					phoneHint: null, // for temporary hint
					phoneMessage: null, // for persistent hint
							page: {
						animation: 'AnimatedFadeIn'
					},
					phonePlaceholder: null,
					phonePrefix: '08',
					phoneSuffix: null,

					phoneMask: '##-####-####', 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					phoneType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// login password
					password: 'Password',

					passwordHint: null, // for temporary hint
					passwordMessage: null, // for persistent hint
					passwordPlaceholder: null,
					passwordPrefix: null,
					passwordSuffix: null,

					passwordMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####
				},
				link: {
					loginButton: {
						replace: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					card: {
						color: 'CardColor',
						dark: 'CardDark',
						elevation: 'CardElevation',
						flat: 'CardFlat',
						hover: 'CardHover',
						light: 'CardLight',
						outlined: 'CardOutlined',
						raised: 'CardRaised',
						tile: 'CardTile'
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: true,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					forgetPasswordButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					},
					signUpButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					},
					loginButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					}
				}
			},
			// (state) log out
			logout: {
				info: {
					hideToolbarMenu: true,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) point page
			point: {
				info: {
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						point: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					pageTitle: null,
					pageSubTitle: null,
					pageTitleButton: null,
				},
				link: {
					pageTitleButton: {
					//	to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			},
			// (state) profile page
			profile: {
				info: {
					isFluidPage: false,

					hideToolbarMenu: true,
					hidePageContents: true,
					showPageTitle: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: true,
						user: true,
						admin: true
					}
				},
				lang: {
					fullName: 'Full Name',
					uid: 'UID',
					email: 'Email',
					phone: 'Phone',
					profilePicture: 'Profile Picture',
					gender: 'Gender',
					age: 'Age',
					addressLine1: 'Addrenn Line 1',
					addressLine2: 'Addrenn Line 2',
					addressLine3: 'Addrenn Line 3',
					city: 'City',
					province: 'Province',
					country: 'Country',
					
					resetPassword: 'Reset Password',
					securityQuestion: 'Security Question'
				},
				link: {
					pageTitleButton: {
						to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					},
					sheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					chip: {
						color: 'ChipColor',
						dark: 'ChipDark',
						label: 'ChipLabel',  // Removes circle edges
						light: 'ChipLight',
						outlined: 'ChipOutlined',
						small: 'ChipSmall',
						textColor: 'ChipTextColor'
					},
					resetPasswordButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					securityQuestionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) reset password page
			resetPassword: {
				info: {
					hideToolbarMenu: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					resetButton: 'Reset',
					cancelButton: 'Cancel',
					okButton: 'OK',

					completedText: 'Password is already reset.',

					// new password
					newPassword: 'New Password',

					newPasswordHint: null, // for temporary hint
					newPasswordMessage: null, // for persistent hint
					newPasswordPlaceholder: null,
					newPasswordPrefix: null,
					newPasswordSuffix: null,

					newPasswordMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					// sign up cofirm password
					confirmPassword: 'Confirm Password',

					confirmPasswordHint: null, // for temporary hint
					confirmPasswordMessage: null, // for persistent hint
					confirmPasswordPlaceholder: null,
					confirmPasswordPrefix: null,
					confirmPasswordSuffix: null,

					confirmPasswordMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####
				},
				link: {
					okButton: {
						to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					resetButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					},
					okButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) secuirty question page
			securityQuestion: {
				info: {
					hideToolbarMenu: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						user: true,
						admin: true
					}
				},
				lang: {
					selectQuestion: 'Select question',
					answerQuestion: 'Answer question',
					submitButton: 'Submit',
					cancelButton: 'Cancel',
					okButton: 'OK',

					completedText: 'Your security questions are successfully set.',
				},
				link: {
					okButton: {
						to: '/'
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					alert: {
						border: 'AlertBorder',
						color: 'AlertColor',
						coloredBorder: 'AlertColoredBorder',
						dark: 'AlertDark',
						dense: 'AlertDense',
						elevation: 'AlertElevation',
						icon: 'AlertIcon',
						light: 'AlertLight',
						outlined: 'AlertOutlined',
						prominent: 'AlertProminent',
						text: 'AlertText',
						tile: 'AlertTile'
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: false,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					submitButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					},
					okButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) sign up page
			signUp: {
				info: {
					hideToolbarMenu: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: true
					}
				},
				lang: {
					loginButton: 'Login',
					cancelButton: 'Cancel',
					signUpButton: 'Sign Up',
					verifyButton: 'Verify',
					registeredText: 'Registered successfully.',
					emailLinkText: 'Email link to login is sent to your email address.',
					okButton: 'OK',

					// select sign up options
					selectSignUpOption: 'Select Sign Up Option',
					selectSignUpOptionHint: null, // for temporary hint
					selectSignUpOptionMessage: null, // for persistent hint
					selectSignUpOptionPlaceholder: null,

					selectSignUpOptionMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					selectSignUpOptionType: null,
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// sign up by email
					email: 'Email',
					emailHint: null, // for temporary hint
					emailMessage: null, // for persistent hint
					emailPlaceholder: null,
					emailPrefix: null,
					emailSuffix: null,

					emailMask: null,
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					emailType: 'email',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown
					
					// sign up by phone
					phone: 'Phone',
					phoneHint: null, // for temporary hint
					phoneMessage: null, // for persistent hint
					phonePlaceholder: null,
					phonePrefix: '08',
					phoneSuffix: null,

					phoneMask: '##-####-####', 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					phoneType: 'text',
					// text
					// number
					// email -> input must include '@'
					// url -> input must begin with 'http(s)://'
					// password -> masked
					// search -> clearable
					// date -> mm/dd/yyyy & calendar (value: yyyy-mm-dd)
					// datetime-local -> mm/dd/yyyy hh:mi AM/PM (value: yyyy-mm-ddThh:mi 24hrs)
					// time -> hh:mi AM/PM (value: hh:mi 24hrs)
					// month -> month yyyy (value: yyyy-mm)
					// hidden -> not shown

					// sign up password
					password: 'Password',

					passwordHint: null, // for temporary hint
					passwordMessage: null, // for persistent hint
					passwordPlaceholder: null,
					passwordPrefix: null,
					passwordSuffix: null,

					passwordMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					// sign up cofirm password
					confirmPassword: 'Confirm Password',

					confirmPasswordHint: null, // for temporary hint
					confirmPasswordMessage: null, // for persistent hint
					confirmPasswordPlaceholder: null,
					confirmPasswordPrefix: null,
					confirmPasswordSuffix: null,

					confirmPasswordMask: null, 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####

					// otp
					otp: 'Input OTP',

					otpHint: null, // for temporary hint
					otpMessage: null, // for persistent hint
					otpPlaceholder: null,
					otpPrefix: null,
					otpSuffix: null,

					otpMask: null 
					// # -> number
					// a -> small letter
					// A -> big letter
					// n -> number or small letter
					// N -> number or big letter
					// date -> ##/##/####
					// time -> ##:##
					// phone -> (###)###-####
					// credit-card -> ####-####-####-####
				},
				link: {
					okButton: {
						replace: '/'
					},
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					select: { // autocomplete component
						backgroundColor: null,
						chips: false,
						clearable: false,
						color: null,
						deletableChips: false,
						dark: false,
						dense: false,
						filled: false,
						flat: false,
						light: false,
						outlined: true,
						smallChips: false,
						solo: false,
						soloInverted: false // Reduces element opacity until focused
					},
					textField: {
						backgroundColor: 'TextFieldBackgroundColor',
						clearable: 'TextFieldClearable', // also possible with search type input
						color: 'TextFieldColor',
						counter: 'TextFieldCounter', // boolean or number
						dark: 'TextFieldDark',
						filled: 'TextFieldFilled',
						flat: 'TextFieldFlat',
						light: 'TextFieldLight',
						outlined: 'TextFieldOutlined',
						solo: 'TextFieldSolo',
						soloInverted: 'TextFieldSoloInverted' // Reduces element opacity until focused
					},
					loginButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					},
					signUpButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					cancelButton: {
						block: 'CancelButtonBlock',
						color: 'CancelButtonColor',
						dark: 'CancelButtonDark',
						depressed: 'CancelButtonDepressed',
						elevation: 'CancelButtonElevation',
						flat: 'CancelButtonFlat',
						large: 'CancelButtonLarge',
						light: 'CancelButtonLight',
						outlined: 'CancelButtonOutlined',
						rounded: 'CancelButtonRounded',
						small: 'CancelButtonSmall'
					},
					okButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					verifyButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) timeline page
			timeline: {
				info: {
					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						nonUser: false,
						anonymous: true,
						user: true,
						admin: true
					}
				},
				lang: {
					replyButton: 'Reply'
				},
				link: {},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					navigationDrawer: {
						dark: false,
						light: false,
						right: false
					},
					timeline: {
						dark: false,
						itemColor: null,
						itemIconColor: null,
						itemLarge: false,
						itemSmall: false,
						light: false
					},
					replyButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					}
				}
			},
			// (state) tutorial page
			tutorial: {
				info: {
					isFluidPage: false,
					
					hideToolbarMenu: false,
					hidePageContents: false,
					showPageTitle: false,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					//
				},
				link: {
					//
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					headerSheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					bodySheet: {
						color: 'SheetColor',
						dark: 'SheetDark',
						elevation: 'SheetElevation',
						light: 'SheetLight'
					},
					actionButton: {
						block: 'ButtonBlock',
						color: 'ButtonColor',
						dark: 'ButtonDark',
						depressed: 'ButtonDepressed',
						elevation: 'ButtonElevation',
						flat: 'ButtonFlat',
						large: 'ButtonLarge',
						light: 'ButtonLight',
						outlined: 'ButtonOutlined',
						rounded: 'ButtonRounded',
						small: 'ButtonSmall'
					},
					videoButton: {
						block: 'FlatButtonBlock',
						color: 'FlatButtonColor',
						dark: 'FlatButtonDark',
						depressed: 'FlatButtonDepressed',
						elevation: 'FlatButtonElevation',
						flat: 'FlatButtonFlat',
						large: 'FlatButtonLarge',
						light: 'FlatButtonLight',
						outlined: 'FlatButtonOutlined',
						rounded: 'FlatButtonRounded',
						small: 'FlatButtonSmall'
					}
				}
			},
			// (state) default page
			unauthorized: {
				info: {
					isFluidPage: false,

					hideToolbarMenu: true,
					hidePageContents: true,
					showPageTitle: true,

					contact: {
						uid: 'admin',
						name: 'Admin'
					},

					menuGroup: {
						all: true
					},

					securityGroup: {
						all: true
					}
				},
				lang: {
					pageTitle: 'Unauthorized',
					pageSubTitle: 'Please login as an authorized user.',
					pageTitleButton: 'Back to home'
				},
				link: {
					pageTitleButton: {
						to: '/',
						method: {
							name: 'switchMenuGroup',
							params: {
								menuGroup: 'default'
							}
						}
					}
				},
				style: {
					page: {
						animation: 'AnimatedFadeIn'
					},
					pageTitleLayout: {
						animation: 'AnimatedFadeIn'
					},
					pageContainer: {
						style: {}
					},
					pageTitleSheet: {
						style: {}
					},
					pageTitleButton: {
						block: 'OutlinedButtonBlock',
						color: 'OutlinedButtonColor',
						dark: 'OutlinedButtonDark',
						depressed: 'OutlinedButtonDepressed',
						elevation: 'OutlinedButtonElevation',
						flat: 'OutlinedButtonFlat',
						large: 'OutlinedButtonLarge',
						light: 'OutlinedButtonLight',
						outlined: 'OutlinedButtonOutlined',
						rounded: 'OutlinedButtonRounded',
						small: 'OutlinedButtonSmall'
					}
				}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
